import { render } from "./HeaderLightfortheworld.vue?vue&type=template&id=a57ec4a4&scoped=true"
import script from "./HeaderLightfortheworld.vue?vue&type=script&lang=js"
export * from "./HeaderLightfortheworld.vue?vue&type=script&lang=js"

import "./HeaderLightfortheworld.vue?vue&type=style&index=0&id=a57ec4a4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a57ec4a4"]])

export default __exports__